import React from "react";
import { FaSync } from "react-icons/fa";


const InputField = ({ label, name, value, onChange, type = "text", autoFocus = false, disabled = false, onClick = false }) => {
    return (
        <div className="mt-2" style={{ display: "flex" }}>
            <div style={{ flex: "5%", display: "flex", alignItems: "center" }}>{label}</div>
            <div style={{ flex: "60%", display: "flex" }}>
                <p style={{ marginRight: "10px", display: "flex", alignItems: "center", height: "100%" }}>:</p>
                <div style={{ width: "100%", outline: "none", padding: "10px 0px", display: "flex" }} >
                    <input
                        autoFocus={autoFocus}
                        type={type}
                        value={value}
                        name={name}
                        onChange={onChange}
                        style={{
                            width: "100%",
                            height: "100%",
                            paddingLeft: "0px",
                            borderTop: "none",
                            borderRight: "none",
                            borderLeft: "none",
                            borderBottom: "1px solid #B6B6B6",
                            outline: "none",
                        }}
                        disabled={disabled}
                    />
                    {onClick && (
                        <div
                            onClick={onClick}
                            style={{
                                height: "70%",
                                marginRight: "5px",
                                backgroundColor: "white",
                                padding: "0px 15px",
                                boxShadow: "1px 1px 3px #8B8B8B",
                                borderRadius: "3px",
                                cursor: "pointer"
                            }}
                        >
                            <FaSync
                                style={{
                                    fontSize: "15px",
                                    color: "#3D64FF",
                                    display: "flex",
                                    alignItems: "center",
                                    height: "100%"
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default InputField;
